import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Markdown from '../lib/Markdown';
import { useContent } from '../content/ContentContext';

const LegalPage: React.FC<{ kind: 'impressum' | 'datenschutz' }> = ({ kind }) => {
  const { legal, settings } = useContent();
  useEffect(() => {
    window.scrollTo({ top: 0 });
    document.title = `${kind === 'impressum' ? 'Impressum' : 'Datenschutz'} · ${settings.siteName}`;
  }, [kind, settings.siteName]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container-site pt-32 pb-24">
        <Link to="/" className="mb-10 inline-flex items-center gap-2 text-sm text-fg-3 hover:text-fg">
          <svg viewBox="0 0 20 20" fill="none" className="h-4 w-4" aria-hidden><path d="M16 10H5m0 0l4-4m-4 4l4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
          Zurück zur Startseite
        </Link>
        <div className="max-w-prose">
          <Markdown source={legal[kind]} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
